import { apiFetchFile } from ".";

export function generateRfaDeclarationXls(year = null, period = "A", country = "FRA", type = "", filter = "") {
  if (!year) year = new Date().getFullYear();
  return apiFetchFile("rfa-declaration-generate?country=" + country
    + "&year=" + year
    + "&type=" + type
    + "&period=" + period
    + "&filter=" + filter);
}

export default {
  generateRfaDeclarationXls
}



// WEBPACK FOOTER //
// ./src/utils/rfa.js